import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ShowMore from 'components/utils/ShowMore';
import { AttendeePersonalInfoItem, AttendeeInfoTitle, AttendeeInfoAnswer } from './sharedComponent';

interface AttendeeCompanyInfoProps {
  companyDesciption: string;
  name: string;
  employees: number;
  estimatedAnnualRevenue: string;
  industry: string;
  sector: string;
  foundedYear: number;
  type: string;
  location: string;
  timeZone: string;
  sicCode: string;
  naicsCode: string;
  linkedin: string;
}

const CompanyBio = styled.div`
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: #A2AAB3;
  margin: 8px;
`;

const InfoLink = styled.a`
  color: #5C8DF3;
`;

const StyledShowMore = styled(ShowMore)`
  text-align: center;
`;

const AttendeeCompanyInfo:FC<AttendeeCompanyInfoProps> = ({
  companyDesciption,
  name,
  employees,
  estimatedAnnualRevenue,
  industry,
  sector,
  foundedYear,
  type,
  location,
  timeZone,
  sicCode,
  naicsCode,
  linkedin,
}) => {
  const { t } = useTranslation();
  return (
    <>
      {companyDesciption && (
        <StyledShowMore
          maxHeight={100}
        >
          <CompanyBio>
            {companyDesciption}
          </CompanyBio>
        </StyledShowMore>
      )}
      {name && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.name', 'Name')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{name}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {employees && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.employees', 'Employees')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{employees}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {estimatedAnnualRevenue && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.estimated_annual_revenue', 'Estimated Annual Revenue')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{estimatedAnnualRevenue}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {industry && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.industry', 'Industry')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{industry}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {sector && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.sector', 'Sector')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{sector}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {foundedYear && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.foundedYear', 'Founded Year')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{foundedYear}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {type && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.type', 'Type')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{type}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {location && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.location', 'Location')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{location}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {timeZone && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.time_zone', 'Time Zone')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{timeZone}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {sicCode && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.sic_code', 'SIC Code')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{sicCode}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {naicsCode && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.naics_code', 'Naics Code')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>{naicsCode}</AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
      {linkedin && (
        <AttendeePersonalInfoItem>
          <AttendeeInfoTitle>{t('attendee_enrichment.linkedin', 'Linkedin')}</AttendeeInfoTitle>
          <AttendeeInfoAnswer>
            <InfoLink href={`https://linkedin.com/${linkedin}`} target="blank">
              {`https://linkedin.com/${linkedin}`}
            </InfoLink>
          </AttendeeInfoAnswer>
        </AttendeePersonalInfoItem>
      )}
    </>
  );
};

export default AttendeeCompanyInfo;
